// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllDownloadsItemActions__container-b127cd {
  width: fit-content;
  display: flex;
  align-items: center;
}

.AllDownloadsItemActions__icons-da502a {
  height: 100%;
  background-color: var(--base-0);
  display: flex;
  align-items: center;
  justify-content: center;
}

.AllDownloadsItemActions__smooth-opacity-ca1acd {
  width: 32px;
  height: 100%;
  background: linear-gradient(270deg, var(--base-0) 0%, transparent 87.5%);
}

.AllDownloadsItemActions__retry-icon-e25753 svg {
  position: relative;
  inset-inline-start: 1px;
}

.AllDownloadsItemActions__remove-icon-b4c840 {
  margin-inline-start: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/AllDownloads/AllDownloadsItemActions/AllDownloadsItemActions.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,wEAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".container {\n  width: fit-content;\n  display: flex;\n  align-items: center;\n}\n\n.icons {\n  height: 100%;\n  background-color: var(--base-0);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.smooth-opacity {\n  width: 32px;\n  height: 100%;\n  background: linear-gradient(270deg, var(--base-0) 0%, transparent 87.5%);\n}\n\n.retry-icon svg {\n  position: relative;\n  inset-inline-start: 1px;\n}\n\n.remove-icon {\n  margin-inline-start: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllDownloadsItemActions__container-b127cd`,
	"icons": `AllDownloadsItemActions__icons-da502a`,
	"smooth-opacity": `AllDownloadsItemActions__smooth-opacity-ca1acd`,
	"smoothOpacity": `AllDownloadsItemActions__smooth-opacity-ca1acd`,
	"retry-icon": `AllDownloadsItemActions__retry-icon-e25753`,
	"retryIcon": `AllDownloadsItemActions__retry-icon-e25753`,
	"remove-icon": `AllDownloadsItemActions__remove-icon-b4c840`,
	"removeIcon": `AllDownloadsItemActions__remove-icon-b4c840`
};
module.exports = ___CSS_LOADER_EXPORT___;
